export const errorMessageFormEditProduct =
  'Você precisa alterar algum dado antes de atualizar o produto';
